//component
import { loginReqType } from './type/LoginType';
import { loginResType } from './type/LoginType';

//apifetch
import axios from 'axios';

//translate
import i18n from '../../translate/i18n';


//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const PostLoginApi = async (data: loginReqType) => {
  try {
    const response = await axios.post<loginResType>(`${baseURL}/auth/login`, {...data}, 
      {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error(error.response?.data || error.message);
    throw error;
  }
};